import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';

@Component({
    selector: 'aur-hidden',
    template: `<div [formGroup]="formGroup" fxFlex>
    <input
        type="hidden"
        [formControlName]="control.name" />
</div>`
})
export class HiddenComponent {

    @Input() formGroup: FormGroup;
    @Input() control: AurFormControl;
}
